import { render, staticRenderFns } from "./SwitchOrganization.vue?vue&type=template&id=5841c4d4&scoped=true&"
import script from "./SwitchOrganization.vue?vue&type=script&lang=ts&"
export * from "./SwitchOrganization.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchOrganization.vue?vue&type=style&index=0&id=5841c4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841c4d4",
  null
  
)

export default component.exports